import {formatNum, formatPercentNum, numFormat} from "@/pages/dashboard/utils/utils";


// 获取指标名称
export const getName = (item, isAvg) => {
    const name = isAvg ? item.avgName : item.name
    return name;
}

// arpu特小值类型指标处理
export const formatLittleNum = (val: any) => {
  const value = val - 0
  if (value > 0 && value < 1 && parseFloat(value?.toFixed(3)) === 0) {
    if (value > 0.00001 || value <= 0.0001) return value?.toFixed(5)
    if (value > 0.0001 || value <= 0.001) {
      return value?.toFixed(4)
    }
    if (value > 0.001 || value <= 0.01) return value?.toFixed(3)
    return parseFloat(value?.toFixed(2))
  }
  return parseFloat(value?.toFixed(2)) ?? '-'
}

/**
 * 可直接formatPercentNum处理， 写此函数的原因：如果后面有变动可以借助此函数配合selectObj里的内容做中间处理
 * @params selectObj：要处理的指标对象，useTopCardList中的
 * @params text: 值
 * @isDod isDod: 是否涨跌
 */
export const getVal = (selectObj, text, isDod=false) => {
    // 指标数据共有 三种类型值
    // 1. 需要用千分位分割的数字
    // 2. 普通百分数
    // 3. 涨跌百分数

    //其实按照现有逻辑直接formatPercentNum(text, selectObj.dodDecimals, isDod)就可以实现
    // 因为formatPercentNum内部有对涨跌的处理，固定保留了一位小数，所以这里暂时用不到dodDecimals
    if (isDod) return formatPercentNum(text, selectObj?.dodDecimals, true)

    if(selectObj?.resName === 'arpu' && text < 1 && text > 0){
      return formatLittleNum(text)
    }
    //后端放回-0数据，未确认数据是否正确，所有先特殊处理
    if (selectObj?.resName === 'refund_revenue' && text <= -0) {
      return '-' + Number(text).toFixed(2);
    }
    // 不是涨跌百分数的处理
    if (selectObj?.isPercent) {
        // 该指标有负数
        if((selectObj?.resName === 'accumulated_refund_rate' || selectObj?.resName === 'lifetime_refund_rate') && text < 0) return '-' + formatPercentNum(text, selectObj?.decimals, false)
        return formatPercentNum(text, selectObj?.decimals, false)
    } else {
      return formatNum(text, false, selectObj?.isUserType);
    }
}

// 用于宽表，转换数据格式以便宽表使用
export const getArrObj = (arr) => {
    let resultObj = {}
    for(let i=0;i<arr?.length;i++){
        resultObj[arr[i].resName] = arr[i]
    }
    return resultObj
}

// 用于宽表 汇总数据格式转换
export const getAggregationObj = (aggregation: any[] = [], localText) => {
  return aggregation.reduce((obj, item) => {
    obj[item.type] = {
      ...item,
      date: localText[item.type],
    }
    return obj;
  }, {});
}

// 将汇总行的数据添加到records中
export const getAllRecords = (tableData, showValue) => {
  if (tableData.aggregationObj) {
    const arr = [];
    showValue.forEach(val => {
      const obj = tableData.aggregationObj[val];
      obj && arr.push(obj);
    })
    return [...tableData.metricsList, ...arr];
  } else return  tableData.metricsList;

}

